interface StackedColumnIconProps {
	size?: number | string;
	color?: string;
}

export function StackedColumnIcon({
	size = 16,
	color,
}: StackedColumnIconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M13.8182 13.818H3.47643C3.1331 13.818 2.80382 13.6816 2.56105 13.4388C2.31827 13.1961 2.18188 12.8668 2.18188 12.5235V2.18164M5.09098 7.99982V10.9089M5.09098 4.36346V5.818M10.9092 5.818V7.99982M8.00007 2.18164V4.36346M8.00007 6.54528V10.9089M10.9092 10.1816V10.9089"
				stroke={color || 'currentColor'}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	);
}
